export default __webpack_public_path__ + "static/BETTERIRL_YELLOW-2e9aecce544af2cc26daf4fc19dee24d.png";